<div class="flex-container gap-8" style="height: 100%">
  <vl-widget-title [text]="'stats_ligne.productivite_ligne' | trans" [widget]="widget()">
    <ng-content/>
    @if (uniteElements().length > 2) {
      <vl-chips-toggle [elements]="uniteElements()" [(value)]="selectedUnite"/>
    }
    <vl-aide-context [sections]="aideSections"/>
  </vl-widget-title>

  @if (stats() === null) {
    <vl-loader-skeleton/>
  } @else if (chartData().labels.length) {
    <div class="chart-area fade-in">
      <canvas #prodChart></canvas>
    </div>
  } @else {
    <div class="flex-row align-center justify-center h100 on-disabled">
      {{ 'stats_ligne.aucune_donnee' | trans }}
    </div>
  }
</div>
